import React from "react";
import { Button, Modal } from "antd";
import { BugOutlined, ExportOutlined } from "@ant-design/icons";

/**
 * ReportIssueModal
 *
 * Asana form URLs are served with X-Frame-Options: DENY, which means no
 * browser will load them inside an <iframe>. This component drops the iframe
 * entirely and opens the form directly in a new tab instead.
 */
export default function ReportIssueModal({ open, onClose, formUrl }) {
  const handleOpen = () => {
    if (formUrl) window.open(formUrl, "_blank", "noopener,noreferrer");
    onClose();
  };

  return (
      <Modal
          open={open}
          onCancel={onClose}
          footer={null}
          title={
            <div className="d-flex align-items-center gap-2">
              <BugOutlined style={{ color: "#f45b68" }} />
              <span className="fw-semibold">Report an Issue</span>
            </div>
          }
          width={480}
          centered
          destroyOnClose
      >
        <div className="text-center py-5 px-3">
          {/* Icon */}
          <div
              className="d-flex align-items-center justify-content-center mx-auto mb-4"
              style={{
                width: 72,
                height: 72,
                borderRadius: "50%",
                background: "#fff0f1",
                border: "2px solid #f45b68",
              }}
          >
            <BugOutlined style={{ fontSize: 32, color: "#f45b68" }} />
          </div>

          <h5 className="fw-bold text-dark mb-2">Found a bug or issue?</h5>

          <p className="text-muted mb-5" style={{ fontSize: 13, maxWidth: 340, margin: "0 auto 24px" }}>
            Our issue form opens in a new tab. Fill it out and we'll
            get back to you as soon as possible.
          </p>

          <div className="d-flex gap-3 justify-content-center">
            <Button onClick={onClose}>Cancel</Button>
            <Button
                type="primary"
                danger
                icon={<ExportOutlined />}
                onClick={handleOpen}
                disabled={!formUrl}
            >
              Open Report Form
            </Button>
          </div>

          {!formUrl && (
              <p className="text-danger mt-3" style={{ fontSize: 12 }}>
                Form URL is not configured.
              </p>
          )}
        </div>
      </Modal>
  );
}